import { z } from "zod";

import { CountryCode } from "../models/partials/CountryCode";
import { TaxInfo } from "../models/partials/TaxInfo";
import { ErrorResponse, SuccessResponse } from "./standard-responses";

export const onboardingEndpoints = {
  "onboarding.purchase.billing.update": (p: { teamDomain: string }) => [
    "up",
    "post",
    `/welcome/${p.teamDomain}/purchase/billing`,
  ],
} as const satisfies Record<string, (p: any) => ["up", "get" | "delete" | "post" | "put", `/${string}`]>;

export const onboardingRequests = {
  "onboarding.purchase.billing.update": z.object({
    teamDomain: z.string(),
    vatNumber: z.string().optional().nullable(),
    invoiceName: z.string().optional().nullable(),
    invoiceAddress: z.string().optional().nullable(),
    invoiceCountry: CountryCode.nullable(),
    invoiceZip: z.string().optional().nullable(),
    invoiceState: z.string().optional().nullable(),
    invoiceEmail: z.string().optional().nullable(),
  }),
} as const;

export const onboardingResponses = {
  "onboarding.purchase.billing.update": SuccessResponse.extend({
    taxInfo: TaxInfo,
  }).or(
    ErrorResponse.extend({
      error: z.literal("validation_error"),
      teamErrors: z.record(onboardingRequests["onboarding.purchase.billing.update"].keyof(), z.string()),
    }),
  ),
} as const;
